import React, {useEffect, useState} from 'react';
import {DashboardHeader} from "../../../components";
import UserProfileForm from "./userProfileForm";
import {getUserDataFromLocalStorage, validateInputs} from "../../../services/utils";
import {Grid} from "@material-ui/core"
import {initialState} from "./constant";
import HttpService from "../../../services/http.service";
import Alert from "../../../components/alert";

const UserProfile = (props) => {

  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(true)
  const [user] = useState([])
  const [countries, setCountries] = useState([])
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  let loginUser = getUserDataFromLocalStorage()
  const {values} = state;
  useEffect(() => {
    setLoading(true)
    HttpService.post('api/business/get?ssoId=' + loginUser.ssoId).then(res => {
      if (res && res.data) {
        //setUser(res.data)
        setLoading(false)

        const val = {
          agriBusinessDetailId: res.data?.agriBusinessDetailId, //
          agriBusinessName: res.data?.agriBusinessName || '', //
          agriBusinessPoc: res.data?.agriBusinessPoc || '',
          agriBusinessWebsite: res.data?.agriBusinessWebsite || "http://localhost.com",
          agriBusinessPocEmail: res.data?.agriBusinessPocEmail || '',
          agriBusinessPocContact: res.data?.agriBusinessPocContact || '',
          country: res.data?.agriMasterId?.agriGeoLocationId?.agriCountryId?.countryCode || "PK",
          state: '',
          cityId: '',
          otherAreas: res.data?.otherAreas || '',
          idCard1: '',
          idCard2: '',
          passport: '',
        }
        setState((preState) => ({
          ...preState, values: {...preState.values, ...val}
        }))
      }
    });
  }, []);
  useEffect(() => {
    HttpService.get('marketplace/countriesList').then(res => {
      if (res) {
        let list = res.data;
        let len = (list && list.length) || 0;
        const array = []
        for (let i = 0; i < len; i++) {
          array.push({text: list[i].countryName, value: list[i].webCode})
        }
        setCountries(array)
      }
    });
  }, []);
  useEffect(() => {
    // let country = "UAE"
    let country = values.countryId
    if (country) {
      HttpService.get(`marketplace/statesByCountry/${country}`).then(res => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = []
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].stateName, value: list[i].stateID})

          }
          setStateList(array)
        }
      });
    }

  }, [values.country]);
  useEffect(() => {
    // let state = "5347"
    let state = values.stateId
    // setCityList([])
    if (state) {
      HttpService.get(`marketplace/cityByStates/${state}`).then(res => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = []
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].cityName, value: list[i].cityID})
          }
          setCityList(array)
        }
      });
    }

  }, [values.state]);
  const updateUser = (e) => {
    e.preventDefault()
    let {
      agriBusinessDetailId,
      agriBusinessName,
      agriBusinessPoc,
      agriBusinessWebsite,
      agriBusinessPocEmail,
      agriBusinessPocContact,
      cityId,
      otherAreas
    } = values;
    let data = {
      agriBusinessDetailId,
      agriBusinessName,
      agriBusinessPoc,
      agriBusinessWebsite,
      agriBusinessPocEmail,
      agriBusinessPocContact,
      cityId,
      otherAreas
    };
    let recordedErrors = validateInputs(data);
    if (Object.keys(recordedErrors).length > 0) {
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      HttpService.post(`api/business/edit?agriBusinessDetailId=${agriBusinessDetailId}&agriBusinessName=${agriBusinessName}&agriBusinessPoc=${agriBusinessPoc}&agriBusinessWebsite=${agriBusinessWebsite}&agriBusinessPocEmail=${agriBusinessPocEmail}&agriBusinessPocContact=${agriBusinessPocContact}&cityId=${cityId}&otherAreas=${otherAreas}&ssoId=${loginUser.ssoId}`).then(res => {
        if (res) {
          if (res?.data?.message === "SUCCESS")
            setSuccess(res?.data?.messageText)
          setTimeout(() => {
            setSuccess("")
          }, 9000);
        } else
          setError(res?.data?.messageText)
        setTimeout(() => {
          setError("")
        }, 9000);
      });
    }
  };
  const verification = (params) => {
    //api/userVerification?userId.ssoId=923338463331&verificationMedia=SMS
    let url = `api/userVerification?verificationMedia=sms&verificationStatus=Y&userId.ssoId=${loginUser.ssoId}`
    if (params === "email")
      url = `api/userVerification?verificationMedia=email&verificationStatus=Y&userId.ssoId=${loginUser.ssoId}`
    HttpService.post(url).then(res => {
      if (res) {
        if (res?.data?.message === "MSG")
          setSuccess(res?.data?.messageText)
        setTimeout(() => {
          setSuccess("")
        }, 9000);
      } else
        setError(res?.data?.messageText)
      setTimeout(() => {
        setError("")
      }, 9000);
    });
  }
  return (
    <Grid container direction={'column'} className=' p-20 content-main-container'>
      {((error || success)) && <Alert type={error ? 'error' : 'success'} message={error || success}/>}
      <DashboardHeader pageTitle={'Business details'}/>
      <UserProfileForm
        verification={verification}
        countries={countries}
        stateList={stateList}
        cityList={cityList}
        state={state}
        updateUser={updateUser}
        setState={setState}
        registerUser={user}
        loading={loading}
      />
      <p className='ml-10 blink_me'><span className='heading-color text-bold font-14'>Note:</span> A digitally verified using all three ways (SMS, Email, and Verified ID) has a better probability of receiving a
        substantial amount of business. Agrilivemarket will also sponsor and promote these events.</p>
    </Grid>
  );
}


export default UserProfile;
